import _defineProperty from "@babel/runtime/helpers/defineProperty";

/* eslint-disable max-len, react/prop-types */
import cc from 'classcat';
import css from './PlusToMinus.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PlusToMinus = function PlusToMinus(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open;
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    className: cc([css.root, _defineProperty({}, css.open, open), className]),
    width: "14px",
    height: "14px",
    role: "presentation",
    viewBox: "0 0 14 14",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Rotating Expand/Collapse Symbols"
    }), /*#__PURE__*/_jsxs("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/_jsx("path", {
        className: css.vertical,
        d: "M14,6 L14,8 L0,8 L0,6 L14,6"
      }), /*#__PURE__*/_jsx("path", {
        className: css.horizontal,
        d: "M14,6 L14,8 L0,8 L0,6 L14,6"
      })]
    })]
  });
};

export default PlusToMinus;